import pluralize from "pluralize"

// Shared DataTableV2 bulk-action factory for "email me an export" flows.
// Feature actions supply a singular `noun`; title/message pluralization is
// derived here so a shape change (e.g. a `disabled` field) is a one-file edit.
export const makeExportAction = ({ noun, onExport }) => {
  const plural = pluralize(noun)
  const titleNoun = `${plural.charAt(0).toUpperCase()}${plural.slice(1)}`

  return {
    label: "Export",
    icon: "file-export",
    iconStyle: "solid",
    onClickBulk: onExport,
    confirm: {
      title: `Export ${titleNoun}`,
      message: (selection = []) =>
        `Export ${selection.length} selected ${pluralize(
          noun,
          selection.length
        )}?`,
      confirmLabel: "Export",
    },
  }
}
